var exports = {
  "tI": "ambientErrorBanner__UNvOd4",
  "kv": "largeBorderRadius__6_vGqA",
  "yH": "mediumBorderRadius__N7yt2Z",
};

module.exports = exports;
